import { componentTypography } from './component.js';
import { semanticTypography } from './semantic.js';
import { systemTypography } from './system.js';
export const typographyTokenMapping = {
    sem: semanticTypography,
    cmp: componentTypography,
    sys: systemTypography
};
//# sourceMappingURL=index.js.map